import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-capture-img-popup',
  standalone: true,
  imports: [LoaderComponent, CommonModule],
  templateUrl: './capture-img-popup.component.html',
  styleUrl: './capture-img-popup.component.scss',
})
export class CaptureImgPopupComponent implements OnInit {
  imageTaken: boolean = false;
  hasCamera: boolean = false;
  @ViewChild('videoRef') videoRef!: ElementRef;
  @ViewChild('canvasRef') canvasRef!: ElementRef;
  capturedImage: any = '';
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CaptureImgPopupComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any[]
  ) {}

  ngOnInit(): void {
    console.log(this.dialogData);
    this.checkCameraAvailability();
  }

  async checkCameraAvailability() {
    try {
      this.loading = true;
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasCamera = devices.some((device) => device.kind === 'videoinput');
      this.loading = false;

      if (hasCamera) {
        // Camera is present
        this.hasCamera = true;
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.videoRef.nativeElement.srcObject = stream;
        this.videoRef.nativeElement.play();
        // Rest of your code for accessing camera stream
      } else {
        // Camera is not available
        this.hasCamera = false;
        console.log('No camera found on the device.');
      }
    } catch (error) {
      // Error occurred while accessing devices
      console.error('Error accessing media devices:', error);
    }
  }

  closeCaptureCameraPopup() {
    this.dialogRef.close();
  }

  onClickProceed() {
    if (this.capturedImage != '') {
      const blobImage = this.convertURItoBlob(this.capturedImage);
      this.dialogRef.close({ data: blobImage });
      this.capturedImage = '';
      this.imageTaken = false;
    }
  }

  convertURItoBlob(dataURI: any) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let index = 0; index < byteString.length; index++) {
      ia[index] = byteString.charCodeAt(index);
    }
    return new Blob([ab], { type: mimeString });
  }

  handleCapture() {
    const context = this.canvasRef.nativeElement.getContext('2d');
    context.drawImage(
      this.videoRef.nativeElement,
      0,
      0,
      this.canvasRef.nativeElement.width,
      this.canvasRef.nativeElement.height
    );
    this.capturedImage = this.canvasRef.nativeElement.toDataURL('image/png');
    this.imageTaken = true;
  }
}
